"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Athena = void 0;
const athenaApi_1 = require("../../private/api-services/athenaApi");
const authData_1 = require("../../private/ephemeral/authData");
class Athena {
    constructor() {
        const user_token = authData_1.Auth.getUserToken();
        const domain_token = authData_1.Auth.getDomainToken();
        if (typeof user_token != 'string' || typeof domain_token != 'string') {
            throw new Error('Cannot use Node service without authenticated user and opened domain!, ' +
                'please use the Authenticator service first');
        }
        this.api = new athenaApi_1.AthenaApi(user_token, domain_token);
    }
    /**
     * Start an Athena Session
     */
    startSession() {
        return this.api.post(`session`, {});
    }
    /**
     * Ask a question
     */
    askQuestion(qData) {
        return this.api.post(`question`, qData);
    }
    /*
    * Get Previous Questions
    * (asked by current user, in current domain)
    */
    getPreviousQuestions() {
        return this.api.get(`question`);
    }
}
exports.Athena = Athena;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXRoZW5hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3B1YmxpYy9zZXJ2aWNlcy9hdGhlbmEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0VBQStEO0FBQy9ELCtEQUFzRDtBQUd0RCxNQUFhLE1BQU07SUFJakI7UUFFRSxNQUFNLFVBQVUsR0FBRyxlQUFJLENBQUMsWUFBWSxFQUFFLENBQUM7UUFDdkMsTUFBTSxZQUFZLEdBQUcsZUFBSSxDQUFDLGNBQWMsRUFBRSxDQUFDO1FBRTNDLElBQUssT0FBTyxVQUFVLElBQUksUUFBUSxJQUFJLE9BQU8sWUFBWSxJQUFJLFFBQVEsRUFBRztZQUN0RSxNQUFNLElBQUksS0FBSyxDQUNiLHlFQUF5RTtnQkFDekUsNENBQTRDLENBQzdDLENBQUE7U0FDRjtRQUVELElBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSxxQkFBUyxDQUFPLFVBQVUsRUFBRSxZQUFZLENBQUUsQ0FBQztJQUM1RCxDQUFDO0lBRUQ7O09BRUc7SUFDSSxZQUFZO1FBQ2pCLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsU0FBUyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3RDLENBQUM7SUFFRDs7T0FFRztJQUNJLFdBQVcsQ0FBQyxLQUE0QztRQUs3RCxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLFVBQVUsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBRUQ7OztNQUdFO0lBQ0ssb0JBQW9CO1FBQ3pCLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDbEMsQ0FBQztDQUVGO0FBN0NELHdCQTZDQyJ9